import { useMemo } from 'react'
import { graphql } from 'relay-runtime'
import { useQuery } from 'relay-hooks/lib/useQuery'
import {
  bestDisplayablePurchasePrices,
  cemeteryMainImage
} from '@lifedot/utils'
import { CemeteryTinyItemProps } from '@lifedot/components/CemeteryTinyItem'
import {
  dependenciesQuery,
  dependenciesQuery$data
} from './__generated__/dependenciesQuery.graphql'
import { CemeteryMarkerQuery$data } from './__generated__/CemeteryMarkerQuery.graphql'

export const useListMapItems = (
  ids: number[]
): [string, dependenciesQuery$data['listMapItems']['items']][] => {
  const { data } = useQuery<dependenciesQuery>(listMapItemsQuery, {
    ids: ids,
    size: 1000
  })

  return useMemo(
    () =>
      Object.entries(
        (data?.listMapItems?.items ?? []).reduce<{
          [lng: number]: dependenciesQuery$data['listMapItems']['items']
        }>((current, item) => {
          const lng = item.location.lng
          const currentLngItems = current[lng]
          return {
            ...current,
            [lng]: currentLngItems ? [...currentLngItems, item] : [item]
          }
        }, {})
      ),
    [data]
  )
}

export const makeMapItem = (
  cemetery: Exclude<CemeteryMarkerQuery$data['item'], null>
): CemeteryTinyItemProps => {
  const { review_summary, main_image, cemetery_types, section_types, sects } =
    cemetery
  const labels = [
    ...section_types,
    ...cemetery_types.filter(({ code }) => code !== 'not_koei'),
    ...sects
  ]
  const review = !review_summary.total_score
    ? undefined
    : { score: review_summary.total_score }

  return {
    cemeteryId: cemetery.cemeteryId,
    name: cemetery.name,
    thumbnail: cemeteryMainImage(main_image),
    purchasePrice: bestDisplayablePurchasePrices(
      cemetery.best_price_by_category
    ),
    labels,
    review
  }
}

const listMapItemsQuery = graphql`
  query dependenciesQuery($ids: [Int!], $size: Int = 500) {
    listMapItems: listCemeteries(
      filter: { ids: $ids }
      page: { from: 0, size: $size }
    ) {
      items {
        cemeteryId: id
        location {
          lat
          lng: lon
        }
      }
    }
  }
`
